export const title = "Navidad - Magic Box - 2022"
export const description = "Feliz Navidad te deseamos este 2022 reclama tu Magic Box"
